/**
 * Canonical fallback timezone used only when a store's `dispensary_time_zone`
 * (and the default store's) is missing. Prefer the per-store
 * `dispensary_time_zone` everywhere; this constant unifies the previously
 * scattered fallbacks (`US/Pacific`, `America/New_York`, `America/Los_Angeles`).
 */
export const DEFAULT_TIME_ZONE = 'US/Pacific';
